<template>
  <v-dialog
    :value="updateExists"
    width="280"
    color="white black--text"
    persistent
  >
    <v-card>
      <v-card-title class="orange lighten-3">
        <h2 class="text-h4 mt-3 mb-1 black--text">
          Minimart has been updated!
        </h2>
      </v-card-title>

      <v-card-text class="pt-6 pb-8">
        <h3 class="text-h5">
          Please reload the page to see the newest version.
        </h3>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-btn
          @click="refreshApp"
          depressed
          class="white--text"
          color="blue darken-2"
          large
          block
          >Reload</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DialogAppUpdate',
  components: {},
  methods: {
    ...mapActions('app', [
      'setOnLineStatus',
      'loadNewVersion',
      'setAppVersionMismatch',
    ]),

    handleControllerChange() {
      if (this.refreshing) return
      this.refreshing = true
      if (this.$gtag) {
        this.$gtag.event('sw_controllerchange_refresh')
      }
      window.location.reload(true)
    },
    updateOnLineStatus(e) {
      this.setOnLineStatus(e.type === 'online')
    },
    showRefresh(e) {
      this.registration = e.detail
      this.updateExists = true
    },
    refreshApp() {
      if (this.appVersionMismatch) {
        this.loadNewVersion()
        return
      }

      this.updateExists = false
      if (!this.registration || !this.registration.waiting) return
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
  computed: {
    ...mapGetters('app', ['version', 'appVersionMismatch']),
  },
  created() {
    if ('serviceWorker' in navigator) {
      document.addEventListener('swUpdated', this.showRefresh, {
        once: true,
      })
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        this.handleControllerChange
      )
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnLineStatus)
    window.addEventListener('offline', this.updateOnLineStatus)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnLineStatus)
    window.removeEventListener('offline', this.updateOnLineStatus)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener(
        'controllerchange',
        this.handleControllerChange
      )
    }
  },
  data() {
    return {
      updateExists: false,
      refreshing: false,
      registration: null,
      appLatestVersion: null,
      versionMismatch: false,
    }
  },
}
</script>
